import React from 'react';
import('./Footer.css')

const Footer = () => {
    return (
        <div className="footer-container">
            <h5> Copyright - 2020 </h5>
            <p><small>Design by <span style={{ color: 'yellow' }}>Mehedi H. Limon</span></small></p>
        </div>
    );
};

export default Footer;